// extracted by mini-css-extract-plugin
export default {"center-container":"Center_center-container__viuJb","center-container-room":"Center_center-container-room__VY0qn","center-container-time":"Center_center-container-time__Cs9TW"};